<template>
  <div>
    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="deletedItem"
        :title="$t('components.extendedbenefitstable.delete_extension_clause')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="editDialog" persistent max-width="1000px">
      <material-card
        :title="
          editedIndex > -1
            ? $t('components.extendedbenefitstable.edit_extension_clause')
            : $t('components.extendedbenefitstable.create_new_extension_clause')
        "
        :color="formColor"
        :icon="formIcon"
        v-if="selectedPlan != null"
      >
        <v-card-text>
          <v-row>
            <v-container>
              <v-row>
                <v-col>
                  <v-form ref="form" v-model="valid">
                    <v-container fluid>
                      <v-row
                        v-if="
                          this.editedItem !== null &&
                            this.editedItem !== undefined
                        "
                      >
                        <div
                          class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4"
                        >
                          <pbas-date-picker
                            :label="
                              $t(
                                'headers.members_management.Extension Termination Date'
                              )
                            "
                            :value="editedItem.ExtensionTerminationDate"
                            @update-date="
                              editedItem.ExtensionTerminationDate = $event
                            "
                            :rules="[
                              $rules.required,
                              rules.extensionTerminationDate,
                            ]"
                            class="required"
                            :allowedDates="extensionTerminationAllowedDates"
                          ></pbas-date-picker>
                        </div>
                        <div
                          class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4"
                        >
                          <!-- add tooltip-->
                          <trans-multi-select2
                            v-model="
                              editedItem.TerminatedExtendedCoverageIdentityIds
                            "
                            :items="computedCoverageIdentities"
                            :label="
                              $t(
                                'components.memberview.terminated_extended_benefits'
                              )
                            "
                            field="Name"
                            itemValue="Id"
                            transPropertyName="Current"
                          ></trans-multi-select2>
                        </div>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="saving" text @click="close">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="saving"
            color="primary"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <material-card
    :title="$t('components.memberview.extension_of_benefits')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="family_restroom"
    >
      <pbas-data-table
        v-if="smartEligibility"
        ref="table"
        :dataProvider="provider"
        fileNamePrefix="extendedBenefits"
        identifier="extendedbenefitstable"
        @error="error = $event"
      ></pbas-data-table>
      <pbas-data-table
        v-else
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="extendedBenefits"
        identifier="extendedbenefitstable"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import ErrorHandler from "../components/ErrorHandler";
import ExtendedBenefitsHeaders from "../headers/ExtendedBenefits";
import TransMultiSelect2 from "../components/TransMultiSelect2";

export default {
  name: "extended-benefits-table",
  components: {
    ErrorHandler,
    TransMultiSelect2,
  },
  props: [
    "extendedBenefits",
    "terminationDate",
    "memberIdentityId",
    "coverageIdentities",
    "smartEligibility"
  ],
  data() {
    return {
      rules: {
        extensionTerminationDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.terminationDate === null ||
            this.terminationDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.terminationDate);
          const d = new Date(n);
          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [
              this.formatValidationDate(d),
            ]);
          }
          const val = new Date(Date.parse(v));
          return (
            val >= d ||
            this.$t("validation.date_{0}", [this.formatValidationDate(d)])
          );
        },
      },
      deletedItem: null,
      deleteValid: true,
      error: null,
      valid: true,
      deleteDialog: false,
      provider: undefined,
      saving: false,
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.editItem({
              Identifier: Math.random(),
            });
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editItem(item),
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            let o;
            if (item.Id) {
              o = this.provider.items.filter((o) => o.Id === item.Id)[0];
            } else {
              o = this.provider.items.filter(
                (o) => o.Identifier === item.Identifier
              )[0];
            }
            this.editedIndex = this.provider.items.indexOf(o);
            this.deletedItem = item;
            this.deleteDialog = true;
          },
        },
      ],
      e6: 1,
      editDialog: false,
      headers: ExtendedBenefitsHeaders,
      editedIndex: -1,
      editedItem: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planParameters: "planOptions",
    }),
    ...mapGetters("plansMembers", ["planIdentity"]),
    formIcon() {
      return this.editedIndex === -1 ? "add" : "edit";
    },
    formColor() {
      return this.editedIndex === -1 ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
    computedCoverageIdentities() {
      if (
        this.coverageIdentities === null ||
        this.coverageIdentities === undefined
      ) {
        return [];
      }

      console.log(this.coverageIdentities, this.extendedBenefits);
      if (this.editedIndex > -1) {
        const used = this.extendedBenefits
          .filter((o) => o.Id !== this.extendedBenefits[this.editedIndex].Id)
          .map((o) => o.TerminatedExtendedCoverageIdentities.map((oo) => oo.Id))
          .flat();
        return this.coverageIdentities.filter(
          (o) => used.filter((oo) => oo === o.Id).length === 0
        );
      }
      const used = this.extendedBenefits
        .map((o) => o.TerminatedExtendedCoverageIdentities.map((oo) => oo.Id))
        .flat();
      return this.coverageIdentities.filter(
        (o) => used.filter((oo) => oo === o.Id).length === 0
      );
    },
  },
  watch: {
    extendedBenefits: {
      handler(v) {
        console.log("extended benefits changed: ", v, this.extendedBenefits);
        this.loadData();
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("plansMembers", [
      "getCurrentMemberBenefits",
      "getExtendableMemberBenefits",
    ]),
    formatValidationDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    extensionTerminationAllowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.terminationDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
    async loadData() {
      if (this.extendedBenefits && this.coverageIdentities) {
        if (this.provider) {
          console.log(
            "load data: ",
            this.extendedBenefits,
            this.coverageIdentities
          );
          this.provider.items = this.extendedBenefits;
          this.$refs.table.getDataAsync();
        } else {
          this.provider = new InMemoryProvider(
            this.extendedBenefits,
            ExtendedBenefitsHeaders
          );
        }
      }
    },
    async editItem(item) {
      let dep;
      if (item.Id) {
        dep = this.provider.items.filter((o) => o.Id === item.Id)[0];
      } else {
        dep = this.provider.items.filter(
          (o) => o.Identifier === item.Identifier
        )[0];
      }
      if (item.Identity === null || item.Identity === undefined) {
        item.Identity = {
          Qualification: {},
        };
      }
      this.editedIndex = this.provider.items.indexOf(dep);
      this.editedItem = JSON.parse(JSON.stringify(item));
      console.log(this.editedItem);

      this.editDialog = true;
    },
    close() {
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.editDialog = false;
      this.editedItem = null;
      this.editedIndex = -1;
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.editedItem));

      if (this.editedIndex > -1) {
        this.update(item);
      } else {
        this.add(item);
      }
    },
    async update(item) {
      // this.extendedBenefitsUpdated(item);
      this.close();
      this.$emit("changed-updated", item);
    },
    async add(item) {
      this.close();
      this.$emit("changed-added", item);
    },
    async tryDelete() {
      let item = JSON.parse(JSON.stringify(this.deletedItem));
      item.IsRemoved = true;
      this.deleteDialog = false;
      this.$emit("changed-removed", item);
    },
    extendedBenefitsUpdated(item) {
      if (item.Id) {
        let updated = this.editedItem.ExtensionClauses.filter(
          (o) => o.Id === item.Id
        )[0];
        console.log(updated);
        let index = this.editedItem.ExtensionClauses.indexOf(updated);
        this.editedItem.ExtensionClauses[index] = item;
      } else {
        let updated = this.editedItem.ExtensionClauses.filter(
          (o) => o.Identifier === item.Identifier
        )[0];
        let index = this.editedItem.ExtensionClauses.indexOf(updated);
        this.editedItem.ExtensionClauses[index] = item;
      }
      this.$forceUpdate();
    },
    extendedBenefitsAdded(item) {
      // this.$nextTick(()=>{
      // console.log(item);
      this.editedItem.ExtensionClauses.push(item);
      // })

      this.$forceUpdate();
    },
    extendedBenefitsRemoved(item) {
      if (item.Id) {
        let removed = this.editedItem.ExtensionClauses.filter(
          (o) => o.Id === item.Id
        )[0];
        removed.EffectiveDate = item.EffectiveDate;
        removed.IsRemoved = true;
      } else {
        let removed = this.editedItem.ExtensionClauses.filter(
          (o) => o.Identifier === item.Identifier
        )[0];
        removed.EffectiveDate = item.EffectiveDate;
        removed.IsRemoved = true;
      }
      this.$forceUpdate();
    },
  },
};
</script>
